import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { AjsResponse, wrapAjs } from "../ajs-response";
import { buildParams, PAGINATION_SEARCH_FIELDS } from "../http-params.util";

/**
 * TicketsApiService (Angular 18).
 *
 * Replaces apps/b2b-ui/common/services/api/ticketsApi/ticketsApi.service.js.
 *
 * `update(props, publish?)` appends `?publish=true` when `publish` is truthy
 * (legacy quirk preserved). Two sub-namespaces:
 *   apiService.tickets.{list,detail,create,update,remove}    (config)
 *   apiService.tickets.printers.list                          (printers)
 */
const TICKETS_CONFIG_BASE_V2 = "/v2/api/administration/tickets/config";
const TICKETS_PRINTERS_BASE_V2 = "/v2/api/printers/config";

@Injectable({ providedIn: "root" })
export class TicketsApiService {
  private readonly http = inject(HttpClient);

  list(props?: Record<string, unknown>): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.get<unknown>(TICKETS_CONFIG_BASE_V2, {
        params: buildParams(props, PAGINATION_SEARCH_FIELDS),
      }),
    );
  }

  detail(id: number | string): Promise<AjsResponse<unknown>> {
    return wrapAjs(this.http.get<unknown>(`${TICKETS_CONFIG_BASE_V2}/${id}`));
  }

  create(props: unknown): Promise<AjsResponse<unknown>> {
    return wrapAjs(this.http.post<unknown>(TICKETS_CONFIG_BASE_V2, props));
  }

  update(props: unknown, publish?: boolean): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.put<unknown>(TICKETS_CONFIG_BASE_V2, props, {
        params: publish ? buildParams({ publish: "true" }) : undefined,
      }),
    );
  }

  remove(id: number | string): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.delete<unknown>(`${TICKETS_CONFIG_BASE_V2}/${id}`),
    );
  }

  readonly printers = {
    list: (props?: Record<string, unknown>): Promise<AjsResponse<unknown>> =>
      wrapAjs(
        this.http.get<unknown>(TICKETS_PRINTERS_BASE_V2, {
          params: buildParams(props, PAGINATION_SEARCH_FIELDS),
        }),
      ),
  };
}
